'use client'
import { useTranslations } from 'next-intl'
import * as React from 'react'
import { tw } from 'utils/classnames'
export const InfoBoxClient = ({ text }: { text: string }) => {
  const [expandText, setExpandText] = React.useState(false)

  const t = useTranslations('pages.clubhouse')
  const handleClick = () => {
    setExpandText(prev => !prev)
  }

  return (
    <div className="flex flex-col justify-between h-full">
      <p
        className={tw(
          'text-14 mt-2 whitespace-pre-wrap font-normal ',
          expandText ? 'line-clamp-none ' : 'line-clamp-3',
        )}
      >
        {text}
      </p>
      <div className="mt-2 w-full">
        <button
          onClick={handleClick}
          className=" text-14 cursor-pointer self-end text-start font-normal underline"
        >
          {expandText ? t('infobox.show_less') : t('infobox.read_more')}
        </button>
      </div>
    </div>
  )
}
